import { ProviderNameEnum } from "@gp/models";
import { AbstractWidgetElement } from "./AbstractWidgetElement";
import { LiveWidgetTypes } from "@data-types/live-widget/LiveWidgetTypes";
import { LMTConfigParams } from "./LMTConfigParams";

export class LMTWidgetElement extends AbstractWidgetElement {
	public provider: ProviderNameEnum;
	public type = LiveWidgetTypes.LMT;
	/** LMT match id */
	public matchId: string;
	/** BR widget options */
	public BRWidgetOptions?: SIROptions;
	/** LS widget options */
	public LSWidgetOptions?: LSOptions;
	public ExeWidgetOptions?: ExeOptions;

	public isError?: boolean;

	constructor(config: LMTConfigParams) {
		super();
		this.sport = config.sport;
		this.provider = config.provider;
		this.matchId = config.matchId;
		this.eventId = config.eventId;
		this.teamOneName = config.teamOneName;
		this.teamTwoName = config.teamTwoName;
		this.location = config.location;
		this.BRWidgetOptions = config.brOptions || {};
		this.LSWidgetOptions = config.lsOptions || {};
		this.ExeWidgetOptions = config.exeOptions || { uid: "tipwin" };
	}
}
